import { useState, useEffect } from 'react'
import { HashRouter, Routes as RouterRoutes, Route } from 'react-router-dom'

import Home from './components/home'
import Program from './components/program'
import WhoWeAre from './components/program/info-pages/who-we-are'
import Platforms from './components/program/info-pages/platforms'
import SatelliteData from './components/program/info-pages/satellite-data'
import ContactInformation from './components/program/info-pages/contact-information'
import Header from './components/header'
import Menu from './components/menu'

const Routes = () => {
  const [activeProgramCodes, setActiveProgramCodes] = useState<string[]>([])
  const [menuActive, setMenuActive] = useState(false)

  useEffect(() => {
    if (menuActive) {
      document.body.classList.add('body_noscroll', 'menu-active')
      document.getElementsByTagName('html')[0].classList.add('body_noscroll')
    } else {
      document.body.classList.remove('body_noscroll', 'menu-active')
      document.getElementsByTagName('html')[0].classList.remove('body_noscroll')
    }
  }, [menuActive])

  return (
    <HashRouter>
      <RouterRoutes>
        <Route
          path="/"
          element={
            <Header
              openMenu={() => setMenuActive(true)}
              closeMenu={() => setMenuActive(false)}
              menuActive={menuActive}
            />
          }
        >
          <Route
            path="/"
            element={
              <Menu
                menuActive={menuActive}
                onToggle={setMenuActive}
                closeMenu={() => setMenuActive(false)}
              />
            }
          >
            <Route
              index
              element={
                <Home
                  activeProgramCodes={activeProgramCodes}
                  onFilterChange={setActiveProgramCodes}
                />
              }
            />

            <Route path="about">
              <Route path="who-we-are" element={<WhoWeAre />} />
              <Route path="platforms" element={<Platforms />} />
              <Route path="satellite-data" element={<SatelliteData />} />
              <Route path="contact" element={<ContactInformation />} />
            </Route>

            <Route path="program/:id" element={<Program />} />
          </Route>
        </Route>
      </RouterRoutes>
    </HashRouter>
  )
}

export default Routes
